import authService from '@/services/authService'

/**
 * Guard de navegación para verificar autenticación
 */
export const authGuard = (to, from, next) => {
  // Rutas públicas que no requieren autenticación
  const publicRoutes = ['/login', '/login-simple', '/error-404', '/reset-password']
  
  // Si la ruta es pública, permitir acceso
  if (publicRoutes.includes(to.path)) {
    next()
    return
  }
  
  // Verificar si el usuario está autenticado (solo verificación local)
  if (authService.isAuthenticated()) {
    // Para simulación, solo verificar que existe el token
    const token = localStorage.getItem('token')
    if (token && token !== 'null' && token !== 'undefined') {
      next()
    } else {
      // Token no válido, redirigir al login
      console.log('Token no válido, redirigiendo a login')
      next('/login')
    }
  } else {
    // No autenticado, redirigir al login
    console.log('Usuario no autenticado, redirigiendo a login desde:', to.path)
    next('/login')
  }
}

/**
 * Guard para redirigir usuarios autenticados desde el login
 */
export const guestGuard = (to, from, next) => {
  if (authService.isAuthenticated()) {
    // Usuario ya autenticado, redirigir al dashboard
    next('/')
  } else {
    next()
  }
}
